<template>
  <!-- 発送リスト -->
  <div id="AppRegularDisposablesView">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">発送リスト</label>
        </div>
      </div>
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <div class="field box is-floating-label">
              <!--1行目 -->
              <div class="columns">
                <div class="column is-one-third">
                  <b-field label="患者コード" labelPosition="on-border">
                    <b-input
                      v-model="searchConditions.patientCode"
                      name="patientCode"
                      type="text"
                      maxlength="8"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="患者名" labelPosition="on-border">
                    <b-input v-model="searchConditions.patientName" name="patientName" type="text"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="営業所コード" labelPosition="on-border">
                    <b-input
                      v-model="searchConditions.officeCode"
                      name="officeCode"
                      data-vv-as="営業所コード"
                      type="text"
                    ></b-input>
                  </b-field>
                </div>
              </div>
              <!--2行目 -->
              <div class="columns">
                <div class="column is-one-third">
                  <b-field label="消耗品品目コード" labelPosition="on-border">
                    <b-input v-model="searchConditions.productCode" name="productCode" type="text"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="消耗品品目名" labelPosition="on-border">
                    <b-input v-model="searchConditions.productName" name="productName" type="text"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="医療機関コード" labelPosition="on-border">
                    <b-input
                      v-model="searchConditions.hospitalCode"
                      name="hospitalCode"
                      data-vv-as="医療機関コード"
                      type="text"
                      maxlength="8"
                    ></b-input>
                  </b-field>
                </div>
              </div>
              <!--3行目 -->
              <div class="columns">
                <div class="column is-one-third">
                  <b-field label="医療機関名" labelPosition="on-border">
                    <b-input
                      v-model="searchConditions.hospitalName"
                      name="hospitalName"
                      data-vv-as="医療機関名"
                      type="text"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="点検担当者コード" labelPosition="on-border">
                    <b-input
                      v-model="searchConditions.staffCode"
                      name="staffCode"
                      data-vv-as="点検担当者コード"
                      type="text"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="点検担当者名" labelPosition="on-border">
                    <b-input
                      v-model="searchConditions.staffName"
                      name="staffName"
                      data-vv-as="点検担当者名"
                      type="text"
                    ></b-input>
                  </b-field>
                </div>
              </div>
              <!--4行目 -->
              <div class="columns">
                <div class="column is-one-third">
                  <b-field label="発送" labelPosition="on-border" class="checkboxButtonField">
                    <b-checkbox-button
                      v-model="searchConditions.regularDeliveryGroup"
                      native-value="1"
                    >あり</b-checkbox-button>
                    <b-checkbox-button
                      v-model="searchConditions.regularDeliveryGroup"
                      native-value="0"
                    >なし</b-checkbox-button>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="キャンセル" labelPosition="on-border" class="checkboxButtonField">
                    <b-checkbox-button v-model="searchConditions.cancelGroup" native-value="1">あり</b-checkbox-button>
                    <b-checkbox-button v-model="searchConditions.cancelGroup" native-value="0">なし</b-checkbox-button>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="ステータス" labelPosition="on-border" class="checkboxButtonField">
                    <b-checkbox-button
                      v-model="searchConditions.regularDisposablesStatusGroup"
                      native-value="1"
                    >確定</b-checkbox-button>
                    <b-checkbox-button
                      v-model="searchConditions.regularDisposablesStatusGroup"
                      native-value="0"
                    >未確定</b-checkbox-button>
                  </b-field>
                </div>
              </div>
              <!--5行目 -->
              <div class="columns">
                <div class="column is-one-third">
                  <b-field label="消耗品発送月" labelPosition="on-border">
                    <b-datepicker
                      v-model="startDate"
                      name="startDate"
                      type="month"
                      placeholder="検索開始年月"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                    ></b-datepicker>
                    <b-datepicker
                      v-model="endDate"
                      name="endDate"
                      type="month"
                      placeholder="検索終了年月"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                    ></b-datepicker>
                  </b-field>
                </div>
              </div>
              <!-- 検索実行ボタン-->
              <div class="columns" style="text-align:center;">
                <div class="column">
                  <b-button
                    class="button"
                    type="is-primary"
                    icon-right="magnify"
                    native-type="button"
                    @click="search(searchConditions)"
                  >検索する</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="columns">
        <div class="column is-two-thirds" style="text-align:left;">
          <b-button
            class="button is-primary has-text-centered"
            icon-left="download"
            native-type="button"
            v-on:click="doDownload"
          >ダウンロード</b-button>
        </div>
        <div class="column">
          <b-field horizontal label="表示件数" style="float:right; white-space:nowrap;">
            <b-select position="is-right" v-model="perPage">
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div>
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="defaultSortDirection"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column
              field="patientCode"
              label="患者コード"
              sortable
              centered
            >{{ props.row.patientCode }}</b-table-column>
            <b-table-column
              field="patientName"
              label="患者名"
              sortable
              centered
            >{{ props.row.patientName }}</b-table-column>
            <b-table-column field="productCode" label="品目名" sortable centered>
              {{ props.row.productName }}
              ({{ props.row.productCode }})
            </b-table-column>
            <b-table-column
              field="disposable"
              label="消耗品品目コード"
              sortable
              centered
            >{{ props.row.disposable }}</b-table-column>
            <b-table-column
              field="disposableName"
              label="消耗品品目名"
              sortable
              centered
            >{{ props.row.disposableName }}</b-table-column>
            <b-table-column
              field="disposablePreDate"
              label="前回供給日"
              sortable
              centered
            >{{ props.row.disposablePreDate }}</b-table-column>
            <b-table-column
              field="disposableInterval"
              label="発送期間"
              sortable
              centered
            >{{ props.row.disposableInterval }}ヶ月</b-table-column>
            <b-table-column
              field="disposableCount"
              label="消耗品個数"
              sortable
              centered
            >{{ props.row.disposableCount }}EA</b-table-column>
            <b-table-column
              field="disposableNextDate"
              label="次回供給予定日"
              sortable
              centered
            >{{ props.row.disposableNextDate }}</b-table-column>
            <b-table-column
              field="staffCode"
              label="担当者コード"
              sortable
              centered
            >{{ props.row.staffCode }}</b-table-column>
            <b-table-column
              field="staffName"
              label="担当者名"
              sortable
              centered
            >{{ props.row.staffName }}</b-table-column>
            <b-table-column
              field="deliveryKindFlag"
              label="定期/非定期"
              sortable
              centered
            >{{ props.row.deliveryKindFlag | deliveryKindFlag }}</b-table-column>
          </template>
        </b-table>
      </div>
      <div class="column" />
      <!-- 戻るボタン -->
      <div>
        <b-button
          v-on:click="back"
          class="button is-primary has-text-centered"
          icon-left="keyboard-backspace"
          native-type="button"
        >戻る</b-button>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
var data = [];
export default {
  name: "AppRegularDisposablesView",
  methods: {
    search: function(searchConditions) {
      // 検索条件の整形
      if (this.startDate && !(typeof this.startDate == "string")) {
        this.searchConditions.startDate = this.formatMonth2(this.startDate);
      }
      if (this.endDate && !(typeof this.endDate == "string")) {
        this.searchConditions.endDate = this.formatMonth2(this.endDate);
      }
      // 検索実行
      var excuteApi = this.getRegularDisposablesDeliveryListPOST;
      var successCallBack = this.getRegularDisposablesDeliveryListSuccess;
      var errorCallBack = this.getRegularDisposablesDeliveryListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getRegularDisposablesDeliveryListPOST: function(client) {
      for (var val in this.searchConditions.regularDeliveryGroup) {
        this.searchConditions.regularDeliveryGroup[val] = parseInt(
          this.searchConditions.regularDeliveryGroup[val]
        );
      }
      for (var val in this.searchConditions.cancelGroup) {
        this.searchConditions.cancelGroup[val] = parseInt(
          this.searchConditions.cancelGroup[val]
        );
      }
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] = parseInt(
          this.searchConditions.regularDisposablesStatusGroup[val]
        );
      }
      return client.apis.apiInspection.getRegularDisposablesDeliveryListPOST({
        body: {
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          officeCode: this.searchConditions.officeCode,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          regularDeliveryFlag: this.searchConditions.regularDeliveryGroup,
          cancelFlag: this.searchConditions.cancelGroup,
          status: this.searchConditions.regularDisposablesStatusGroup,
          startMonth: this.searchConditions.startDate,
          endMonth: this.searchConditions.endDate
        }
      });
    },
    getRegularDisposablesDeliveryListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var val in this.searchConditions.regularDeliveryGroup) {
        this.searchConditions.regularDeliveryGroup[val] =
          this.searchConditions.regularDeliveryGroup[val] + "";
      }
      for (var val in this.searchConditions.cancelGroup) {
        this.searchConditions.cancelGroup[val] =
          this.searchConditions.cancelGroup[val] + "";
      }
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] =
          this.searchConditions.regularDisposablesStatusGroup[val] + "";
      }
    },
    getRegularDisposablesDeliveryListError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      for (var val in this.searchConditions.regularDeliveryGroup) {
        this.searchConditions.regularDeliveryGroup[val] =
          this.searchConditions.regularDeliveryGroup[val] + "";
      }
      for (var val in this.searchConditions.cancelGroup) {
        this.searchConditions.cancelGroup[val] =
          this.searchConditions.cancelGroup[val] + "";
      }
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] =
          this.searchConditions.regularDisposablesStatusGroup[val] + "";
      }
    },
    doDownload: function() {
      var excuteApi = this.downloadRegularDisposablesDeliveryListFilePOST;
      var errorCallBack = this.downloadFileError;
      // WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },
    downloadRegularDisposablesDeliveryListFilePOST: function(client) {
      //整形
      for (var val in this.searchConditions.regularDeliveryGroup) {
        this.searchConditions.regularDeliveryGroup[val] = parseInt(
          this.searchConditions.regularDeliveryGroup[val]
        );
      }
      for (var val in this.searchConditions.cancelGroup) {
        this.searchConditions.cancelGroup[val] = parseInt(
          this.searchConditions.cancelGroup[val]
        );
      }
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] = parseInt(
          this.searchConditions.regularDisposablesStatusGroup[val]
        );
      }
      return client.apis.apiInspection.downloadRegularDisposablesDeliveryListFilePOST(
        {
          body: {
            patientCode: this.searchConditions.patientCode,
            patientName: this.searchConditions.patientName,
            officeCode: this.searchConditions.officeCode,
            productCode: this.searchConditions.productCode,
            productName: this.searchConditions.productName,
            hospitalCode: this.searchConditions.hospitalCode,
            hospitalName: this.searchConditions.hospitalName,
            staffCode: this.searchConditions.staffCode,
            staffName: this.searchConditions.staffName,
            regularDeliveryFlag: this.searchConditions.regularDeliveryGroup,
            cancelFlag: this.searchConditions.cancelGroup,
            status: this.searchConditions.regularDisposablesStatusGroup,
            startMonth: this.searchConditions.startDate,
            endMonth: this.searchConditions.endDate
          }
        }
      );
    },
    downloadFileError: function(result) {
      this.showErrorMessage(result);
    },
    back: function(event) {
      this.$router.push({
        name: "AppRegularDisposablesSearch"
      });
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var searchConditions = {
      patientCode: "",
      patientName: "",
      officeCode: "",
      productCode: "",
      productName: "",
      hospitalCode: "",
      hospitalName: "",
      staffCode: "",
      staffName: "",
      startDate: "",
      endDate: "",
      regularDeliveryGroup: ["1"],
      cancelGroup: ["0"],
      regularDisposablesStatusGroup: []
    };
    var startDate = this.getDeliveryMonthDate();
    var endDate = this.getDeliveryMonthDate();
    if (this.$route.params["deliveryMonth"]) {
      var deliveryMonth = this.$route.params["deliveryMonth"];
      if (typeof deliveryMonth == "string" && deliveryMonth != "") {
        deliveryMonth = this.parseDateMonth(deliveryMonth);
      }
      startDate = deliveryMonth;
      endDate = deliveryMonth;
    }
    if (userInfo.roleId != 1 && userInfo.roleId != 2) {
      searchConditions.officeCode = userInfo.officeCode;
      searchConditions.staffCode = userInfo.staffCode;
      searchConditions.staffName = userInfo.fullName;
    }
    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,
      searchConditions,
      userInfo,
      startDate,
      endDate
    };
  },
  searchs: {},
  components: {},
  mounted: function() {
    // WebApi Call
    // this.search(this.searchConditions);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppRegularDisposablesView.vue